import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.PostTypeFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/post_type/post_type_filter"]
  selectAll: true

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet
    @title = "Post type"

  destroy: () ->
    this.remove()
    return false

  addFilter: (value) ->
    @searchQuery.addPostType(value)

  render: ->
    @$el.html(@template(title: @title, self: @))
    return this

